"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-component--select-card" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = ["value"];
const _hoisted_4 = {
    key: 1,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_colony = (0, vue_1.resolveComponent)("colony");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)((_ctx.playerinput.coloniesModel || []), (colony) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                class: "cardbox",
                key: colony.name
            }, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedColony) = $event)),
                    value: colony.name
                }, null, 8, _hoisted_3), [
                    [vue_1.vModelRadio, _ctx.selectedColony]
                ]),
                (0, vue_1.createVNode)(_component_colony, { colony: colony }, null, 8, ["colony"])
            ]));
        }), 128)),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    onClick: _ctx.saveData,
                    title: _ctx.playerinput.buttonLabel,
                    disabled: !_ctx.canSave()
                }, null, 8, ["onClick", "title", "disabled"])
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
